import { Skeleton, Stack } from '@mui/material'

export const SkeletonTerms = () => (

  <>
  <Stack direction={'row'} spacing={1.5} width={'100%'} height={'2em'} alignItems="stretch" justifyContent="stretch">
    <Skeleton animation="wave" width={'1.2em'}/>
    <Skeleton animation="wave" sx={{flexGrow: 10}}/>
  </Stack>
  <Stack direction={'row'} spacing={1.5} width={'100%'} height={'2em'} alignItems="stretch" justifyContent="stretch">
    <Skeleton animation="wave" width={'1.2em'}/>
    <Skeleton animation="wave" sx={{flexGrow: 10}}/>
  </Stack>
  <Stack direction={'row'} spacing={1.5} width={'100%'} height={'2em'} alignItems="stretch" justifyContent="stretch">
    <Skeleton animation="wave" width={'1.2em'}/>
    <Skeleton animation="wave" sx={{flexGrow: 10}}/>
  </Stack>
  </>
)